import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

export default function ProductPQernel() {
  const { lang } = useLanguage();
  const isEn = lang === 'en';
  const isJa = lang === 'ja';

  const features = isEn
    ? [{ icon: 'ri-stack-line', text: 'Not limited to a single plastic type' }, { icon: 'ri-loop-right-line', text: 'Unlimited recycling cycles' }, { icon: 'ri-test-tube-line', text: 'Low-cost adoption, dosage approx. 500–1000 ppm' }, { icon: 'ri-settings-3-line', text: 'Process-friendly, directly usable in existing compounding, injection, and extrusion lines' }]
    : isJa
    ? [{ icon: 'ri-stack-line', text: '単一プラスチック材質に限定されない' }, { icon: 'ri-loop-right-line', text: 'リサイクル回数無制限' }, { icon: 'ri-test-tube-line', text: '低コスト導入、添加量約500〜1000 ppm' }, { icon: 'ri-settings-3-line', text: 'プロセスフレンドリー、既存の造粒・射出・押出ラインで直接使用可能' }]
    : [{ icon: 'ri-stack-line', text: '不限單一塑料種類' }, { icon: 'ri-loop-right-line', text: '不限次數再生' }, { icon: 'ri-test-tube-line', text: '低成本導入，添加量約 500–1000 ppm' }, { icon: 'ri-settings-3-line', text: '製程友善，可直接在既有造粒、射出、押出產線使用' }];

  const targets = isEn
    ? [{ icon: 'ri-recycle-line', label: 'Plastic Recyclers & Shredders' }, { icon: 'ri-settings-3-line', label: 'Plastic Compounders' }, { icon: 'ri-building-line', label: 'Injection & Extrusion Manufacturers' }, { icon: 'ri-leaf-line', label: 'Brand ESG / Circular Economy Projects' }]
    : isJa
    ? [{ icon: 'ri-recycle-line', label: 'プラスチックリサイクル・粉砕業者' }, { icon: 'ri-settings-3-line', label: 'プラスチック造粒業者' }, { icon: 'ri-building-line', label: '射出・押出メーカー' }, { icon: 'ri-leaf-line', label: 'ブランドESG・サーキュラーエコノミープロジェクト' }]
    : [{ icon: 'ri-recycle-line', label: '塑膠回收與粉碎廠' }, { icon: 'ri-settings-3-line', label: '塑膠造粒廠' }, { icon: 'ri-building-line', label: '射出、押出製造廠' }, { icon: 'ri-leaf-line', label: '品牌端 ESG / 循環經濟專案' }];

  const specs = isEn
    ? [{ label: 'Dosage', value: '500–1000 ppm' }, { label: 'Compatible Resins', value: 'rABS / rPET / rPE / rPP / Composite' }, { label: 'Integration', value: 'Direct addition to shredded or compounded material' }, { label: 'Equipment', value: 'No equipment changes required' }, { label: 'Patents', value: 'TW · JP · EU · US' }]
    : isJa
    ? [{ label: '添加量', value: '500〜1000 ppm' }, { label: '対応材質', value: 'rABS / rPET / rPE / rPP / 複合プラスチック' }, { label: '導入方法', value: '粉砕料または造粒料に直接混合' }, { label: '設備要件', value: '既存設備の変更不要' }, { label: '特許状況', value: '台湾・日本・EU・米国' }]
    : [{ label: '添加量', value: '500–1000 ppm' }, { label: '適用材質', value: 'rABS / rPET / rPE / rPP / 複合塑料' }, { label: '導入方式', value: '直接混入粉碎料或造粒料' }, { label: '設備需求', value: '無需更換既有設備' }, { label: '專利狀態', value: '台灣 · 日本 · 歐盟 · 美國' }];

  const sectionLabel = isEn ? 'Functional Additive' : isJa ? '機能性添加剤' : '功能型添加劑';
  const title = isEn ? 'PQernel® Nano Chain Extender' : isJa ? 'PQernel® ナノ鎖延長補強剤' : 'PQernel® 聚量奈米擴鏈補強劑';
  const body = isEn
    ? 'PQernel® is a proprietary nano-scale polymer chain extender developed by PolyQ. It can be directly added to shredded or compounded waste plastics, significantly improving mechanical strength and processing stability of recycled plastics without changing existing equipment.'
    : isJa
    ? 'PQernel®は聚量応用材料が独自開発したナノスケール高分子鎖延長補強剤です。廃プラスチックの粉砕料や造粒料に直接添加でき、既存設備を変更することなく再生プラスチックの機械的強度と加工安定性を大幅に向上させます。'
    : 'PQernel® 是聚量自主開發的奈米級高分子擴鏈補強劑，可直接加入廢棄塑膠粉碎料或造粒料，在不改變既有設備的前提下，大幅提升再生塑料的機械強度與加工穩定性。';
  const featuresLabel = isEn ? 'Product Features' : isJa ? '製品特長' : '產品特色';
  const targetsLabel = isEn ? 'Target Users' : isJa ? '対象ユーザー' : '適用對象';
  const specsLabel = isEn ? 'Product Specifications' : isJa ? '製品仕様' : '產品規格';
  const patentBadge = isEn ? 'TW · JP · EU · US Patents' : isJa ? '台湾・日本・EU・米国特許' : '台灣 · 日本 · 歐盟 · 美國專利';
  const ctaLabel = isEn ? 'Schedule PQernel® Consultation' : isJa ? 'PQernel®技術相談を予約' : '預約 PQernel® 技術諮詢';
  const imgAlt = isEn ? 'PQernel® Nano Chain Extender' : isJa ? 'PQernel® ナノ鎖延長補強剤' : 'PQernel® 奈米擴鏈補強劑';

  return (
    <section className="section-padding bg-white overflow-hidden">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-10 rounded-full bg-gradient-to-b from-brand-green to-brand-blue flex-shrink-0" />
          <div>
            <p className="text-[1rem] font-semibold text-brand-green uppercase tracking-widest">{sectionLabel}</p>
            <h2 className="font-bold text-neutral-dark" style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.3' }}>{title}</h2>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div>
            <p className="text-neutral-mid mb-7" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>{body}</p>
            <div className="mb-8">
              <p className="text-[1rem] font-semibold text-neutral-dark mb-4 uppercase tracking-wide">{featuresLabel}</p>
              <div className="space-y-3">
                {features.map((f) => (
                  <div key={f.text} className="flex items-start gap-3 p-3.5 rounded-xl bg-[#F5F8FB] border border-neutral-border">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-brand-green-light flex-shrink-0">
                      <i className={`${f.icon} text-brand-green text-base`}></i>
                    </div>
                    <span className="text-neutral-dark text-[1.0625rem] leading-relaxed">{f.text}</span>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <p className="text-[1rem] font-semibold text-neutral-dark mb-4 uppercase tracking-wide">{targetsLabel}</p>
              <div className="grid grid-cols-2 gap-3">
                {targets.map((t) => (
                  <div key={t.label} className="flex items-center gap-2.5 p-3 rounded-xl bg-brand-green-light border border-brand-green/20">
                    <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                      <i className={`${t.icon} text-brand-green text-base`}></i>
                    </div>
                    <span className="text-neutral-dark text-[0.9375rem] font-medium leading-tight">{t.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div>
            <div className="relative rounded-2xl overflow-hidden mb-6" style={{ height: '280px' }}>
              <img src="https://readdy.ai/api/search-image?query=nano%20polymer%20PQernel%20additive%20white%20fine%20powder%20granules%20in%20laboratory%20setting%20with%20molecular%20chain%20visualization%20green%20technology%20glow%20clean%20white%20background%20professional%20macro%20product%20photography%20industrial%20material%20science&width=640&height=280&seq=pqernel-detail-v1&orientation=landscape" alt={imgAlt} className="w-full h-full object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
              <div className="absolute bottom-4 left-4">
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-brand-green text-white text-[0.9375rem] font-semibold">
                  <i className="ri-award-line text-sm"></i>{patentBadge}
                </span>
              </div>
            </div>
            <div className="rounded-card border border-neutral-border overflow-hidden" style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.06)' }}>
              <div className="px-5 py-3.5 bg-[#F5F8FB] border-b border-neutral-border">
                <p className="text-[1rem] font-semibold text-neutral-dark uppercase tracking-wide">{specsLabel}</p>
              </div>
              <div className="divide-y divide-neutral-border">
                {specs.map((s) => (
                  <div key={s.label} className="flex items-center px-5 py-3.5 gap-4">
                    <span className="text-neutral-mid text-[1rem] w-28 flex-shrink-0">{s.label}</span>
                    <span className="text-neutral-dark text-[1rem] font-medium">{s.value}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-5">
              <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-brand-green text-white text-[1.0625rem] font-semibold hover:bg-brand-green-dark transition-all duration-200 whitespace-nowrap cursor-pointer">
                <i className="ri-calendar-schedule-line"></i>{ctaLabel}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
